var path = '/app/pages/raise-funds/raise-funds.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/raise-funds/raise-funds.html
// module id = 371
// module chunks = 0